import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'sam4-spinner',
    templateUrl: './spinner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent {
}
